module.exports = __webpack_public_path__ + "img/initiate-fu-from-profile.e10596fc.gif";